import { createRouter, createWebHistory } from 'vue-router'

// 1. Vues Principales & Publiques
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import RegisterView from '@/views/RegisterView.vue'
import ForgotPasswordView from '@/views/ForgotPasswordView.vue'
import ResetPasswordView from '@/views/ResetPasswordView.vue'

// 2. Vues Métier / Dashboard (Protégées)
import ProjectsView from '@/views/ProjectsView.vue'
import ProjectDetailView from '@/views/ProjectDetailView.vue'
import KanbanView from '@/views/KanbanView.vue'
import ComptesView from '@/views/ComptesView.vue'

// 3. Paramètres (Protégés)
import ProfileSettings from '@/views/ProfileSettings.vue'
import SecuritySettings from '@/views/SecuritySettings.vue'
import CategorySettings from '@/views/CategorySettings.vue'

// 4. Pages Secondaires & Légales (Publiques)
import AboutView from '@/views/AboutView.vue'
import AideView from '@/views/AideView.vue'
import CguView from '@/views/CguView.vue'
import CgvView from '@/views/CgvView.vue'
import ConfidentialiteView from '@/views/ConfidentialiteView.vue'
import MentionsLegalesView from '@/views/MentionsLegalesView.vue'
import MaintenanceView from '@/views/MaintenanceView.vue'

const routes = [
  // --- ACCUEIL (PAGE DE VENTE SI VISITEUR / DASHBOARD SI CONNECTÉ) ---
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: { requiresAuth: false } // JAMAIS de redirection vers login ici !
  },

  // --- AUTHENTIFICATION (PUBLIQUES) ---
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { requiresAuth: false, guestOnly: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    meta: { requiresAuth: false, guestOnly: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordView,
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPasswordView,
    meta: { requiresAuth: false }
  },

  // --- ESPACE PRIVÉ (PROTÉGÉ : requiresAuth = true) ---
  {
    path: '/projects',
    name: 'Projects',
    component: ProjectsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/projects/:id',
    name: 'ProjectDetail',
    component: ProjectDetailView,
    meta: { requiresAuth: true }
  },
  {
    path: '/kanban',
    name: 'Kanban',
    component: KanbanView,
    meta: { requiresAuth: true }
  },
  {
    path: '/comptes',
    name: 'Comptes',
    component: ComptesView,
    meta: { requiresAuth: true }
  },

  // --- RÉGLAGES (PROTÉGÉS) ---
  {
    path: '/settings/profile',
    name: 'ProfileSettings',
    component: ProfileSettings,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/security',
    name: 'SecuritySettings',
    component: SecuritySettings,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/categories',
    name: 'CategorySettings',
    component: CategorySettings,
    meta: { requiresAuth: true }
  },

  // --- PAGES LÉGALES ET SUPPORT (PUBLIQUES) ---
  {
    path: '/about',
    name: 'About',
    component: AboutView,
    meta: { requiresAuth: false }
  },
  {
    path: '/aide',
    name: 'Aide',
    component: AideView,
    meta: { requiresAuth: false }
  },
  {
    path: '/cgu',
    name: 'Cgu',
    component: CguView,
    meta: { requiresAuth: false }
  },
  {
    path: '/cgv',
    name: 'Cgv',
    component: CgvView,
    meta: { requiresAuth: false }
  },
  {
    path: '/confidentialite',
    name: 'Confidentialite',
    component: ConfidentialiteView,
    meta: { requiresAuth: false }
  },
  {
    path: '/mentions-legales',
    name: 'MentionsLegales',
    component: MentionsLegalesView,
    meta: { requiresAuth: false }
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: MaintenanceView,
    meta: { requiresAuth: false }
  },

  // Redirection automatique des routes inconnues vers l'accueil
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// =========================================================================
// GARDE DE NAVIGATION (Sécurité)
// =========================================================================
router.beforeEach((to, from, next) => {
  // On vérifie les deux formats de token utilisés dans ton application
  const token = localStorage.getItem('token') || localStorage.getItem('giraaf_token')
  const isAuthenticated = Boolean(token)

  // 1. Si la route DEMANDE une connexion et que le visiteur n'est PAS connecté
  if (to.meta.requiresAuth && !isAuthenticated) {
    return next({ name: 'Login' })
  }

  // 2. Si le visiteur est DÉJÀ connecté et essaie d'aller sur /login ou /register
  if (to.meta.guestOnly && isAuthenticated) {
    return next({ name: 'Home' })
  }

  // 3. Dans tous les autres cas (notamment l'accès à la page d'accueil '/') -> ON LAISSE PASSER
  next()
})

export default router
